import {useSignInContext} from "../context/SignInContextProvider";
import {UsernamePasswordForm} from "./UsernamePasswordForm";
import {MfaMethodSelector} from "./MfaMethodSelector";
import {MfaVerificationForm} from "./MfaVerificationForm";

export function SignInContent() {
    const {signInAttempt} = useSignInContext();

    let content = null;
    if (!signInAttempt || signInAttempt.reviewStatus == "pass") {
        content = <UsernamePasswordForm/>;
    } else if (!signInAttempt.mfaMethod) {
        content = <MfaMethodSelector/>;
    } else {
        content = <MfaVerificationForm/>;
    }

    return content;
}